import mpx, { observable, watch } from '@mpxjs/core'
import { getRecommendGoods, setPageShareConfig } from '../../../biz'
import { sendRecOrderRequest } from '../../../common_methods'
import { EnumGoodsStatus, EnumGoodsDetailIsSpike } from '../../../defines/enums'
import { GlobalEnv, initEnv, login } from '../../../global_env'
import { URLQueries } from '../../../global_env/url_query'
import { getErrorMessage } from '../../../utils/error'
import { navigateTo, setTitle, redirectTo } from '../../../utils/ui'
import { FnBridge } from './fn_bridge'
import { isSoldOut } from '../page_detail/judge'
import { Track, createErrorTrack } from './track'
import { runAsyncHooks, runHooks } from './utils'
import {
  getTrackUrl,
  hideGoodDetailModule,
  cannotUseHarmonyosShare,
} from '../../../../js/util'
import {
  trackEvent,
  is,
  query,
  hashQuery,
  utils,
  xenv,
  canIUse,
  invokeShare,
  goTo,
  build,
} from '@didi/webx-js'
import { callIsLogin } from '@/lib/webx/global_env/login'
import { restoreTokenToUrl } from '../../../../js/token-guard'
import { showVersion } from '../page_detail/const'
import {
  TechPageErrorNoFromAndXenv,
  TechPageErrorXenvError,
  TechGoodsProcessCreateOrderError,
} from '@/lib/webx/tech_error_track'
import {
  getformateLangMessage,
  getProdConfFromApollo,
} from '../../../global_env/get_prod_config'
import { dealPageErrno, Errno } from '@/lib/webx/api'
import { getDoingGoodsInfo } from '@/lib/webx/biz/process'
import { MASErrorTrackGetDoingInfoError } from '@/lib/webx/mas_error_track'
import { GROUP_POP } from './const'

// TODO: 临时改紧急 bugX
const extra = { lang: GlobalEnv.lang }
if (__mpx_mode__ === 'web') {
  extra.source = getTrackUrl()
}
window.mallTrackEvent = function (key, name, events) {
  trackEvent(key, name, {
    fr: xenv(),
    ...extra,
    ...events,
  })
}

/**
 * PageConfig {
 * needLogin,
 * needLocation
 * hooks: {
 *   beforeGetDetail: () || [],
 *   afterGetDetail: () || [],
 *    beforeOrder: () || [], // async
 *    afterOrder: () || []
 *    beforeRender: () || []
 *  }
 * }
 */

const DefaultPageConfig = {
  needLogin: true,
  hooks: {},
}

/** 不下线商品交互 */
const offlineGoodsHandler = async function () {
  const res = await mpx.showModal({
    type: 'confirm',
    title: this.$t('common.goodsOffline'),
    confirmText: this.$t('common.seeMoreDeals'),
    cancelText: this.$t('common.confirm'),
  })
  if (res.confirm) {
    navigateTo('index', {
      city_id: GlobalEnv.cityId,
      productType: URLQueries.getQuery('productType') || '',
    })
  }
}

/** 设置支付完成后跳转信息 */
const setPayExtra = function () {
  const prodConfTextFromApollo = getProdConfFromApollo(
    this.$data.$_.goods.productType,
    {
      searchKey: 'goods_process',
    }
  )
  if (
    this.$data.$_.goods.orderLandingPage &&
    this.$data.$_.goods.orderLandingButton
  ) {
    this.$data.$_.payExtra = {
      successUrl: this.$data.$_.goods.orderLandingPage,
      successText: this.$data.$_.goods.orderLandingButton,
    }
    // TODO apollos数据是否需要改驼峰
  } else if (
    prodConfTextFromApollo?.dache_btn_link &&
    !prodConfTextFromApollo?.dache_btn_hide
  ) {
    const successText = getformateLangMessage(
      prodConfTextFromApollo?.dache_btn_text
    )
    this.$data.$_.payExtra = {
      successUrl: prodConfTextFromApollo?.dache_btn_link,
      successText,
    }
  }
}

/** 获取商品详情 */
const getDetail = async function (hooks) {
  try {
    runHooks.call(this, hooks.beforeGetDetail)
    const id = this.$data.$_.order_info || URLQueries.getQuery('orderId')
    const data = await getDoingGoodsInfo(id)
    const { group, goods, order, pop, goodsInstance, cashback } = data || {}
    if (
      goods.showVersion === showVersion.nOrder &&
      goods.useTripNumPackage?.[0]?.package
    ) {
      goods.package = goods.useTripNumPackage[0].package
    }
    this.$data.$_.group = group
    this.$data.$_.pop = pop
    this.$data.$_.goods = goods
    this.$data.$_.buyerList = data.buyer_list
    this.$data.goodsInstance = goodsInstance
    this.$data.$_.cashback = cashback
    runHooks.call(this, hooks.afterGetDetail, { goods, group, order })
    this.pageStyle = {
      backgroundColor: '#fcfdfe',
    }
    Number(goods.auditStatus) === EnumGoodsStatus.Offline &&
      offlineGoodsHandler.call(this)
    setPayExtra.call(this)
  } catch (error) {
    // 内置请求需要.extra，trade-sdk中不需要extra
    const errorData = error.extra || {}
    if (__mpx_mode__ === 'web') {
      document.getElementById('loading')?.remove()
    }
    MASErrorTrackGetDoingInfoError(error?.errmsg, error)
    this.pageErrno = dealPageErrno(errorData)
    if (errorData.errno === Errno.GoodsCanNotBuy) {
      redirectTo('index')
    }
  }
}

/** 生成渲染数据 */
const render = function (hooks) {
  const goods = this.$data.$_.goods
  // 双重保证，避免后端刷缓存将n单商品刷为普通商品时展示
  const isNorder =
    goods.showVersion === showVersion.nOrder && goods.useTripNumPackage
  const queryInfo = Object.assign({}, query(), hashQuery())
  const MallRenderData = {
    template: 'normal',
    // TODO: 这里需要加个唯一 ID, 后面循环组件的话，key 用 name 不太保险，万一需要一个组件渲染两次
    components: [
      {
        name: 'top-header',
        data: {
          hideTitle: goods?.extra?.hideTitle,
          title: goods.goodsName,
          goodsType: goods.goodsType,
          desc: goods.extra && goods.extra.goodsTopText,
          currency: goods.currency,
          totalSave: goods.totalSave,
          couponNumber: goods.cardShow?.couponNumber,
          backgroundImage: goods.extra && goods.extra.goodsInfoPic,
          currentPage: 'goodsProcess',
          ...isSoldOut(goods),
        },
      },
      ...(isNorder
        ? [
            {
              name: 'n-coupon-packages',
              data: {
                list: goods.useTripNumPackage || [],
                currency: goods.currency,
                productType: goods.productType,
              },
            },
          ]
        : [
            {
              name: 'coupon-packages-list',
              data: {
                list: goods.package || [],
                currency: goods.currency,
                productType: goods.productType,
              },
            },
          ]),
      {
        name: 'guideline-list',
        data: {
          customPicList: goods?.extra?.customPic,
        },
      },
      {
        name: 'usable-scope',
        data: {
          goods,
        },
      },
      {
        name: 'guideline',
        data: {
          extraPic: goods.extra?.extraPic,
        },
      },
      ...(goods.isSpike === EnumGoodsDetailIsSpike.Group
        ? [
            {
              name: 'group-rules',
              data: {},
            },
          ]
        : []),
      {
        name: 'rules',
        data: {
          goodsDesc: goods.goodsDesc,
        },
      },
      {
        name: 'city-info',
        data: {
          cityDesc: goods.cityDesc,
        },
      },
      {
        name: 'supplementar',
        data: {
          goodsExtraDesc: goods.goodsExtraDesc,
        },
      },
      {
        name: 'conditions',
        data: {},
      },
      {
        name: 'recommend-list',
        data: {
          list: this.$data.$_.recommendList,
          event: this.$data.$_.recOrder.event,
          isSoldOut: isSoldOut(goods).soldOut,
          isEnd: goods.endTime < goods.currentTime,
        },
        hide: hideGoodDetailModule('recommend-list'),
      },
    ],
  }
  // 在IOS 微信小程序环境下存在滚动穿透问题，临时将按钮和页面内容拆分开，调整层级修复一下问题
  // 其中包含吸底按钮、拼团4个状态弹窗。层级较高 因此放在一起
  const topLayerRenderData = {
    template: 'top-layer',
    components: [
      ...(goods.isSale === 0 || queryInfo?.only_show
        ? []
        : [
            {
              name: 'operations',
              data: {
                isLogin: GlobalEnv.isLogin,
                isSoldOut: isSoldOut(goods).soldOut,
                price: goods.showCash,
                currency: goods.currency,
                showText: goods.showText,
                showVersion: goods.showVersion,
                markType: goods.markType,
                goods: goods,
                buyerList: this.$data.$_.buyerList,
                group: this.$data.$_.group,
                cashback: this.$data.$_.cashback,
                productType: goods.productType,
              },
            },
          ]),
    ],
  }
  const res = runHooks.call(this, hooks.beforeRender, MallRenderData, goods)
  this.MallRenderData = res || MallRenderData
  if (this.$data.$_.pop) {
    const type = this.$data.$_.pop?.type || ''
    if (type) {
      topLayerRenderData.components.push({
        name: GROUP_POP[type],
        data: {
          type: type,
          goods: goods,
          group: this.$data.$_.group,
        },
      })
    }
  }
  // 在IOS 微信小程序环境下存在滚动穿透问题，临时将按钮和页面内容拆分开，调整层级修复一下问题
  this.topLayerRenderData = topLayerRenderData
  window.PerfTrack?.coreImageReady?.({
    url: utils.webpUrl(goods.extra.goodsInfoPic),
  })
  window.PerfTrack?.customTTI?.({
    resources: [
      utils.webpUrl(goods.extra.goodsInfoPic),
      'https://dpubstatic.udache.com/static/dpubimg/fb241e2d-bfab-4239-9300-eba1268e706a.png',
      'https://dpubstatic.udache.com/static/dpubimg/f809b2f3-7596-4461-aa82-23d6777e200c.png',
    ],
  })
}

const ObservableGlobalEnv = observable(GlobalEnv)

const getPageInfoAndRender = async function (hooks) {
  // 两个请求并发，但是要保证 detail 回来，运行完 render 函数，有了 MallRenderData 之后，再更新推荐的渲染数据
  const p1 = getDetail.call(this, hooks)
  const p2 = GlobalEnv.isLogin
    ? getRecommendGoods({
        goodsId: URLQueries.getQuery('id'),
      })
    : Promise.resolve({ list: [] })
  window.PerfTrack?.requestBegin?.()
  try {
    await p1
    render.call(this, hooks)
  } catch (error) {} // 错误上面已经处理了
  window.PerfTrack?.responseReady?.()
  this.$nextTick(() => {
    window.PerfTrack?.domReady?.({ isKey: true })
  })
  const { list, event } = await p2
  this.$data.$_.recommendList = list
  // TODO: 秒杀的时候，老逻辑没有保存算法埋点数据？确认：故意的还是漏了？
  this.$data.$_.recOrder.event = event
  if (Array.isArray(this.MallRenderData.components)) {
    const components = this.MallRenderData.components.find(
      component => component.name === 'recommend-list'
    )
    components && (components.data.list = list)
  }
}
/**
 * 检查商品使用城市
 * @param {*} goods 商品
 */
const checkGoodsCityid = function () {
  if (this.pageErrno) {
    return
  }
  const goods = this?.$data?.$_?.goods || {}
  // 仅在端内检测
  if (is('passenger')) {
    // 以下保留原有逻辑
    const cityId = Number(GlobalEnv.locationInfo?.cityId)
    // 全国商品不处理
    if (Number(goods.cityId) === 0) {
      return
    }
    const goodsCityid = goods.cityId?.split(',') || []
    if (
      !cityId ||
      Number(cityId) === -1 ||
      goodsCityid.map(item => Number(item)).indexOf(cityId) === -1
    ) {
      mpx.showToast({
        title: this.$t('goodsDetail.limitCityMsg'),
        icon: 'none',
      })
      return
    }
  }

  if (goods.notifyToast) {
    mpx.showToast({
      title: goods.notifyToast,
      icon: 'none',
    })
  }
}

export const initBaseFlow = async (PageConfig = {}) => {
  try {
    if (is('miniprogram') && !query().from && !query().xenv) {
      TechPageErrorNoFromAndXenv()
    }
    if (is('miniprogram') && query().xenv === 'h5') {
      TechPageErrorXenvError()
    }
  } catch (error) {}
  let needLocation
  // 抖音小程序整改，不需要定位
  if (xenv() === 'dymp') {
    needLocation = false
  } else {
    needLocation =
      typeof PageConfig.needLocation === 'boolean'
        ? PageConfig.needLocation
        : true
  }
  console.log('-initBaseFlow--needLocation', needLocation)
  await initEnv({
    needLocation,
    needLogin: true,
    beforeInitPlantFormFn: () => {
      setTitle(PageConfig.title || mpx.i18n.t('home.title'))
    },
  })
  document.body.classList?.add(GlobalEnv.lang.toLowerCase())
}

const _afterCreateOrderError = async error => {
  if (error && error.statusCode && error.statusCode >= 500) {
    mpx.showToast({
      title: this.$t('common.sellFast'),
      icon: 'none',
    })
  } else if (error.message === 'Response Error.') {
    const { errno, errmsg } = error
    switch (errno) {
      case 12028:
        mpx.showModal({
          content: this.$t('common.unavailableBuy'),
          showCancel: false,
        })
        break
      case 11004:
        mpx
          .showModal({
            content: this.$t('common.goodsOffline'),
          })
          .then(res => {
            if (res.confirm) {
              navigateTo('index', {
                city_id: GlobalEnv.cityId,
                channelId: GlobalEnv.channelId,
              })
            }
          })
        break
      default:
        mpx.showToast({
          title: errmsg,
          icon: 'none',
        })
    }
  } else {
    mpx.showToast({
      title: getErrorMessage(error),
      icon: 'none',
    })
  }
}

export const PageGoodsProcessMixin = PageConfig => ({
  async onLoad() {
    window.PerfTrack?.jsReady?.()
    const config = (PageConfig = {
      ...DefaultPageConfig,
      ...PageConfig,
    })
    await initBaseFlow(config)
    // 这里不用 await 的原因：后面的异步操作可以并行，并且不会 throw error
    await getPageInfoAndRender.call(this, config.hooks).then(() => {
      Track.pageShow.call(this)
      // 处理当定位城市不在商品的适用城市，弹toast
      checkGoodsCityid.call(this)
    })
    setPageShareConfig({
      pathname: 'goodsProcess',
      isDetail: true,
      shareConfigRequestParams: {
        goodsId: URLQueries.getQuery('id'),
      },
      extraQueries: {
        groupId: this.$data.$_.group.groupId || URLQueries.getQuery('groupId'),
      },
    })
      .then(config => {
        this.$data.$_.shareConfig = config
      })
      .catch(() => {})
    watch(
      () => ObservableGlobalEnv.isLogin,
      async n => n && getPageInfoAndRender.call(this, config.hooks)
    )
    FnBridge.createOrder = async arg => {
      try {
        await runAsyncHooks.call(this, config.hooks.beforeOrder)
        GlobalEnv.hasRecOrderEventParams &&
          sendRecOrderRequest({
            ...GlobalEnv.eventParams,
            event_type: 'ord',
            event_time: Date.now(),
            item_id: URLQueries.getQuery('id'),
          })
        if (!GlobalEnv.isLogin) {
          await login()
          return
        }
        if (this.$data.$_.isFinished) {
          mpx.showToast({
            title: this.$t('spikeDetail.promotionEnded'),
            icon: 'none',
          })
          return
        }
        const _args = (arg && arg[0]) || {}
        // 参团时无需校验库存
        if (this.$data.$_.isSoldOut && !_args.noNeedCheckGoods) {
          mpx.showToast({
            title: this.$t('spikeDetail.goodsSoldOut'),
            icon: 'none',
          })
          return
        }
        const params = {
          goods_id: this.$data.$_.goods?.goodsId || URLQueries.getQuery('id'),
        }
        if (_args.source_id) {
          params.source_id = _args.source_id
        }
        this.$data.$_.goods.disRule &&
          this.$data.$_.goods.disRule.disId &&
          Object.assign(params, {
            dis_id: this.$data.$_.goods.disRule.disId,
          })
        const activityType = _args.orderBySpike
        const createOptions = {}
        if (this.$data.$_.goods.isSpike === EnumGoodsDetailIsSpike.Group) {
          createOptions.isCreateNewGroup = _args.isCreateNewGroup
        }
        const res = await this.$data.goodsInstance?.buy?.(activityType, {
          payOptions: {
            noSuccessUrl: true,
          },
          noNeedCheckGoods: _args.noNeedCheckGoods,
          params: params,
          createOptions,
          hooks: {
            // 下单后支付前的hooks
            afterCreateOrder: {
              async: true,
              action: this.afterCreateOrderBeforeBuy,
            },
          },
        })
        const { id, group_id } = res?.orderRes?.data || {}
        this.$data.createOrderFlag = false
        // TODO: 小程序埋点修复。新版的小程序返回才 resolve.
        Track.buySuccess.call(this, res)
        GlobalEnv.hasRecOrderEventParams &&
          sendRecOrderRequest({
            ...GlobalEnv.eventParams,
            event_type: 'finish',
            event_time: Date.now(),
            item_id: URLQueries.getQuery('id'),
          })
        await runAsyncHooks.call(this, config.hooks.afterOrder, {
          errno: 0,
          orderId: id,
          orderBySpike: arg?.[0]?.orderBySpike,
          groupId: group_id,
        })
      } catch (error) {
        this.$data.createOrderFlag = false
        if (error?.code === 2) return
        const createOrderError = error?.errType === 'CREATEORDER'
        if (createOrderError) {
          _afterCreateOrderError.call(this, error)
          // createErrorTrack(error?.errno || 1, error, '0000')
          TechGoodsProcessCreateOrderError(error)
          return error
        }
        if (!createOrderError && error?.errType && error?.errMsg) {
          mpx.showToast({
            title: error.errMsg,
            icon: 'none',
          })
          createErrorTrack(error?.errno || 1, error, '0000')
          return error
        }
        await runAsyncHooks.call(this, config.hooks.afterOrder, {
          errno: 1,
          error,
        })
      }
    }
    FnBridge.refreshDetailInfo = async args =>
      getPageInfoAndRender.call(this, config.hooks, args)
    this.$nextTick(() => {
      callIsLogin()
    })
  },
  data: {
    $_: {
      isSpike: false,
      isFinished: false, // 活动结束标记，目前只有秒杀用了。秒杀下单返回 is_finished, 会记录到这里，再点击下单就不重复请求了。
      isSoldOut: false, // 售罄标记，目前只有秒杀用了。秒杀下单返回 is_soldout, 会记录到这里，再点击下单就不重复请求了。
      goods: {},
      group: {},
      pop: {},
      recommendList: [],
      // 智能算法埋点数据
      recOrder: {
        event: {},
      },
      payExtra: {
        successUrl: '',
        successText: '',
      },
      shareConfig: {},
      cashback: 0, // 拼团返现金额
    },
    MallRenderData: {},
    topLayerRenderData: {}, // 高层级组件渲染数据
    pageStyle: {},
    buyerList: [], // 购买列表,length>1时展示在按钮左上方
    pageErrno: 0,
    createOrderFlag: false,
    goodsInstance: null,
  },
  methods: {
    $_onMallPageEvent(params) {
      const { method, args } = params.detail
      if (typeof this[method] === 'function') {
        this[method](...args)
      }
    },
    share() {
      if (cannotUseHarmonyosShare()) {
        mpx.showToast({
          title:
            '抱歉，当前APP系统版本不支持该操作，可以在升级版本后尝试此操作',
          icon: 'none',
          duration: 2000,
        })
        return
      }
      if (xenv() === 'h5') {
        mpx.showToast({
          title: this.$t('common.h5ShareToast'),
          icon: 'none',
          duration: '3000',
        })
        return
      }
      canIUse('invokeShare') && invokeShare(this.$data.$_.shareConfig)
    },
    afterCreateOrderBeforeBuy(res, options) {
      const { id, group_id, free_order_info } = res.data || {}
      const successParams = {}
      if (
        options.isSpike === EnumGoodsDetailIsSpike.Group &&
        options.activityType === EnumGoodsDetailIsSpike.Group
      ) {
        successParams.groupId = group_id
        successParams.orderId = id
        successParams.id = options.goodsId
      }
      // 拼团0元套餐不需要拉支付,直接生成订单
      if (free_order_info) {
        if (!free_order_info?.url) return { isStop: true }
        restoreTokenToUrl()
        goTo({
          url: build(free_order_info.url, free_order_info.params),
        })
        return { isStop: true }
      }
      return { successParams }
    },
  },
})
